import { session } from './session'
import { localStore } from './local'

/** Separate fallback data for every account; guest data is never imported. */
export function personalStore<T>(name: string, initial: T) {
  const stores = new Map<string, ReturnType<typeof localStore<T>>>()
  const active = () => {
    const owner = session.get()?.user.id ?? 'guest'
    const key = `saadhan.${name}.${owner}`
    let store = stores.get(key)
    if (!store) {
      store = localStore(key, initial)
      stores.set(key, store)
    }
    return store
  }
  // Drop unknown-owner legacy data even on an already-authenticated reload.
  try { localStorage.removeItem(`saadhan.${name}`) } catch { /* memory only */ }
  const listeners = new Set<() => void>()
  let store = active()
  let unsubscribe = store.subscribe(() => listeners.forEach((l) => l()))
  session.subscribe(() => {
    const next = active()
    if (next === store) return
    unsubscribe()
    // A fresh guest session must not resurrect data from a previous visitor.
    if (!session.get()) next.set(initial)
    store = next
    unsubscribe = store.subscribe(() => listeners.forEach((l) => l()))
    listeners.forEach((l) => l())
  })
  return {
    get: () => store.get(),
    set: (value: T) => store.set(value),
    subscribe(listener: () => void) {
      listeners.add(listener)
      return () => { listeners.delete(listener) }
    },
  }
}
